<template>
<div class="chapter">
<div class="inner_page">
<p class="centerc1"><a id="page_ii"></a>C<span class="small">RITICAL</span> A<span class="small">MERICA</span></p>
<p class="centerc">General Editors: R<span class="small">ICHARD</span> D<span class="small">ELGADO</span> and J<span class="small">EAN</span> S<span class="small">TEFANCIC</span></p>
<p class="centerc">White by Law:<br/>The Legal Construction of Race<br/>Ian Haney López</p>
<p class="centerc">Cultivating Intelligence:<br/>Power, Law, and the Politics of Teaching<br/>Louise Harmon and Deborah W. Post</p>
<p class="centerc">Privilege Revealed:<br/>How Invisible Preference Undermines America<br/>Stephanie M. Wildman<br/>with Margalynne Armstrong, Adrienne D. Davis, and Trina Grillo</p>
<p class="centerc">Does the Law Morally Bind the Poor?<br/>or What Good’s the Constitution When You Can’t Afford a Loaf of Bread<br/>R. George Wright</p>
<p class="centerc">Hybrid:<br/>Bisexuals, Multiracials, and Other Misfits under American Law<br/>Ruth Colker</p>
<p class="centerc">Critical Race Feminism:<br/>A Reader<br/>Edited by Adrien Katherine Wing</p>
<p class="centerc">Immigrants Out!<br/>The New Nativism and the Anti-Immigrant Impulse in the United States<br/>Edited by Juan F. Perea</p>
<p class="centerc">Taxing America<br/>Edited by Karen B. Brown and Mary Louise Fellows</p>
<p class="centerc">Notes of a Racial Caste Baby:<br/>Colorblindness and the End of Affirmative Action<br/>Bryan K. Fair</p>
<p class="centerc">Please Don’t Wish Me a Merry Christmas:<br/>A Critical History of the Separation of Church and State<br/>Stephen M. Feldman</p>
<p class="centerc">To Be an American:<br/>Cultural Pluralism and the Rhetoric of Assimilation<br/>Bill Ong Hing</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm1.vue?dc507226